import { FeatureScope, OrgUnitType } from '@retail/mgpris/config-types';
import { PriceSuggestionType } from '@retail/products/types';

export type BindingLevel = 'ASSORTMENT' | 'SUPPLIER';

interface PriceSuggestionTypeRule {
  bindingLevels: BindingLevel[];
  scopes: FeatureScope[];
}

const ALL_LEVELS: BindingLevel[] = ['ASSORTMENT', 'SUPPLIER'];
const RETAIL_LOCATION: FeatureScope = { orgUnitType: OrgUnitType.RETAIL_LOCATION };
const RETAIL_LOCATION_NO: FeatureScope = {
  orgUnitType: OrgUnitType.RETAIL_LOCATION,
  country: 'NO',
};
const RETAIL_LOCATION_SE: FeatureScope = {
  orgUnitType: OrgUnitType.RETAIL_LOCATION,
  country: 'SE',
};
const WHOLESALE_LOCATION: FeatureScope = { orgUnitType: OrgUnitType.WHOLESALE_LOCATION };

export const priceSuggestionTypeRules: Record<PriceSuggestionType, PriceSuggestionTypeRule> = {
  MARKUP: { bindingLevels: ['SUPPLIER'], scopes: [RETAIL_LOCATION] },
  MG_AGGRESSIVE: { bindingLevels: ['SUPPLIER'], scopes: [RETAIL_LOCATION] },
  MG_CONSERVATIVE: { bindingLevels: ['SUPPLIER'], scopes: [RETAIL_LOCATION] },
  MG_MODERATE: { bindingLevels: ['SUPPLIER'], scopes: [RETAIL_LOCATION] },
  FINFO_BASE: { bindingLevels: ['SUPPLIER'], scopes: [RETAIL_LOCATION_SE] },
  FINFO_RECOMMENDED: { bindingLevels: ['SUPPLIER'], scopes: [RETAIL_LOCATION_SE] },
  LOCAL: { bindingLevels: ALL_LEVELS, scopes: [RETAIL_LOCATION, WHOLESALE_LOCATION] },
  BRAND: { bindingLevels: ALL_LEVELS, scopes: [RETAIL_LOCATION] },
  MG_VVS: { bindingLevels: ALL_LEVELS, scopes: [RETAIL_LOCATION_NO] },
};
